const topbar = {
    docs: '文件',
    help: '幫助',
    subscription: '訂閱',
};
export default Object.freeze(topbar);
